import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormGroup, Input } from "reactstrap";
import { Form, Link } from "../../assets/styles/components";
import Submit from "../../components/Submit";
import ContentBox from "../../components/ContentBox";
import { Creators as SessionCreators } from "../../store/ducks/session";

const submitLogin = (e, authenticate) => {
  e.preventDefault();
  const toSubscription = window.location.search.includes("subscriprion=go");
  const queryString = new URLSearchParams(window.location.search);

  authenticate(
    e.target.username.value.trim(),
    e.target.password.value.trim(),
    toSubscription,
    queryString
  );
};

const Signin = ({ loading, sessionCreate }) => (
  <Fragment>
    <ContentBox title="Entrar">
      <Form
        accept-charset="UTF-8"
        onSubmit={e => submitLogin(e, sessionCreate)}
      >
        <FormGroup>
          <Input name="username" placeholder="Celular ou Email" required />
        </FormGroup>
        <FormGroup>
          <Input name="password" placeholder="Senha" type="password" required />
        </FormGroup>
        <Submit loading={loading} name="Entrar" />
      </Form>
      <Link to="/password/new" className="linkClean">
        Esqueceu sua senha?
      </Link>
      <br />
      <Link to="/signup" className="linkClean">
        Criar conta
      </Link>
    </ContentBox>
  </Fragment>
);

const mapStateToProps = state => ({
  loading: state.session.loading
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(SessionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Signin);



// WEBPACK FOOTER //
// ./src/pages/signin/index.js